import React from 'react';
import { ScrollArea } from '@/components/ui/scroll-area';
import { cn } from '@/lib/utils';

// Header gradient per result type
export const PANEL_ACCENTS = {
    folders: 'from-amber-50/50 dark:from-amber-950/20',
    links: 'from-primary/10 dark:from-primary/10',
    messages: 'from-violet-50/50 dark:from-violet-950/20',
};

/**
 * Bordered results card: fixed header (title, count, pagination) above a scrollable list.
 * Renders `results` (FolderResults / LinkResults / MessageResults) twice, once in
 * headerOnly and once in contentOnly mode, with the same props.
 * @param {React.ComponentType} results - Results component to render
 * @param {string} accent - Key of PANEL_ACCENTS
 * @param {string} className - Extra classes for the card
 * @param {React.Ref} bodyRef - Optional ref to the scrollable body (e.g. to measure it)
 */
const ResultsPanel = ({ results: Results, accent, className, bodyRef, ...props }) => (
    <div className={cn("flex flex-col rounded-lg border border-border/60 bg-card overflow-hidden", className)}>
        <div className={cn("shrink-0 px-3 py-2 border-b border-border/50 bg-gradient-to-b to-transparent", PANEL_ACCENTS[accent])}>
            <Results {...props} headerOnly={true} />
        </div>
        <div ref={bodyRef} className="flex-1 min-h-0">
            <ScrollArea className="h-full">
                <Results {...props} contentOnly={true} />
            </ScrollArea>
        </div>
    </div>
);

export default ResultsPanel;
